<nav v-if="show_back_button" class="navbar navbar-expand-lg bg-light sticky-top px-0 onboarding-navbar">
  <div class="container-fluid px-0 py-0">
    <div class="d-flex align-items-center ms-3">
      <a class="border-0 d-flex align-items-center me-3" id="navbar_logo">
        <img :src="$clientLogo" alt="Logo" class="logo-img mt-2" width="120px" />
      </a>
    </div>

    <div class="d-flex align-items-center ms-auto">
      <router-link to="/" class="nav-link me-3 text-xxs btn btn-sm p-2 btn-primary-dark rounded-small"
        data-bs-toggle="tooltip" data-bs-placement="bottom" title="Go back to the home page">
        Back
      </router-link>
    </div>
  </div>
</nav>

<div class="login-root" :class="{ 'with-bars': show_back_button }">

  <!-- Edge-to-edge Glass Shell -->
  <div class="glass-shell">

    <!-- LEFT: Marketing Banner -->
    <div class="login-left d-none d-lg-flex">
      <div class="login-copy">
        <h1 class="headline"></h1>
        <p class="subtitle"></p>
        <p class="description"></p>
      </div>
    </div>

    <!-- RIGHT: Login (CENTERED) -->
    <div class="login-right">
      <div class="login-card">
        <div class="text-center mb-1 p-0">
          <img :src="$clientLogo" class="img-fluid" width="100" />
        </div>

        <h5 class="mb-1 text-xs text-center p-0">{{ title }}</h5>

        <form @submit.prevent="submitForm">
          <slot name="form-content"></slot>

          <button v-if="show_default_submit_button" type="submit" class="btn btn-primary-dark shadow w-100 mb-1"
            :disabled="verification_running">
            <span v-if="verification_running" class="d-inline-flex align-items-center justify-content-center gap-2">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Checking...
            </span>
            <span v-else>{{ submit_button_text }}</span>
          </button>

          <slot name="custom-button"></slot>
          <slot name="signup-content"></slot>
        </form>
      </div>
    </div>
  </div>
</div>

<AICampusFooter v-if="show_back_button" />
